export const CategoriesEndpoint = {
  GET_ALL_CATEGORIES: '/api/admin/category',
  SYNC_CATEGORIES: '/api/admin/category/sync',
  SYNC_SUBCATEGORIES: '/api/admin/category/subcategory/sync',
  UPDATE_SUBCAT_IMAGE: '/api/admin/category/:category/:subcategory',
  TOGGLE_SHOW_IN_APP: '/api/admin/category/:category/toggleShowInApp',
};
